import constant from '../utils/constant';
import { apiRequest } from '../utils/useAPIRequest';
import useFetcher from '../utils/useFetcher';

const createPlan = async payload => {
	const { status, errorMessage } = await apiRequest({
		url: '/business-subscription/create-plan',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};
const updatePlan = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/business-subscription/update-plan?id=${id}`,
		method: 'patch',
		payload,
	});
	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const useGetPlans = () => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.subscriptionPlans],
		url: '/business-subscription/plans',
		paginate: true,
	});
};
const useGetSubs = () => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.subscriptions],
		url: '/business-subscription',
		paginate: true,
	});
};

const useGetSubsPayments = ({ customer }) => {
	return useFetcher({
		queryKey: [constant.apiQueryKey.subscriptionPayments, customer],
		url: '/transactions/transactions/business',
		paginate: true,
		initialFilter: {
			customer: customer,
		},
	});
};

const PlansBillingController = {
	createPlan,
	useGetPlans,
	updatePlan,
	useGetSubs,
	useGetSubsPayments,
};

export default PlansBillingController;
